export default __webpack_public_path__ + "static/media/3163.911b5b57.svg";